module.exports = __webpack_public_path__ + "media/bgm.23233adf.mp3";